import { ReactNode } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ConfirmationDialog from '../../../../components/layout/ConfirmationDialog'

type PageLayoutProps = {
  title: string
  subtitle?: string
  children: ReactNode
  actions?: ReactNode
  showBack?: boolean
  showCancel?: boolean
  showSave?: boolean
  showDelete?: boolean
  saveDisabled?: boolean
  onSave?: () => void
  onDelete?: () => void
}

const PageLayout = ({
  title,
  subtitle,
  children,
  actions,
  showBack,
  showCancel,
  showSave,
  showDelete,
  saveDisabled,
  onSave,
  onDelete,
}: PageLayoutProps) => {
  const navigate = useNavigate()

  return (
    <Stack padding={3} spacing={3} sx={{ flex: 1, minHeight: 0 }}>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <Stack>
          <Typography variant="h4" data-testid="entity-page-title">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="subtitle1" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Stack>
        {actions && (
          <Stack direction="row" sx={{ alignItems: 'center' }} data-testid="entity-page-actions">
            {actions}
          </Stack>
        )}
      </Stack>
      <Stack sx={{ flex: 1, minHeight: 0 }}>{children}</Stack>
      <Stack direction="row" spacing={3} sx={{ alignItems: 'center', justifyContent: 'flex-end', flexShrink: 0 }}>
        {showBack && (
          <Button onClick={() => navigate(-1)} data-testid="entity-action-back">
            Back
          </Button>
        )}
        {showCancel && (
          <Button onClick={() => navigate(-1)} data-testid="entity-action-cancel">
            Cancel
          </Button>
        )}
        {showDelete && onDelete && (
          <ConfirmationDialog
            title={`There may still be references to this entity in the system. Are you sure you want to
                      delete this entity? This action cannot be undone.`}
            content={<Typography>Delete</Typography>}
            onConfirm={onDelete}
            triggerTestId="entity-action-delete"
            cancelTestId="entity-action-delete-cancel"
            confirmTestId="entity-action-delete-confirm"
            dialogTestId="entity-action-delete-dialog"
          />
        )}
        {showSave && onSave && (
          <Button variant="contained" onClick={onSave} disabled={saveDisabled} data-testid="entity-action-save">
            Save
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default PageLayout
